<template>
	<div>
		<v-app>
			<v-overlay :value="attempting" z-index="1000">
				<v-progress-circular
				indeterminate
				size="100"
				></v-progress-circular>
			</v-overlay>
			<v-navigation-drawer v-model="drawer" color="white" app floating :width="navbar" class="nav-shadow">
				<v-list color="white" light>
					<v-list-item>
						<v-list-item-action>
							<v-icon>mdi-warehouse</v-icon>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>MASTER WAREHOUSE</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-list  color="grey lighten-4" light flat>
					<v-subheader class="font-weight-bold">Logistic Delivery</v-subheader>
				</v-list>

				<v-list dense class="pt-0 cus-m-navbar">
					<div>
						<v-list-item link router :to="{name: 'driver'}" color="primary lighten-1">
							<v-list-item-action>
								<v-icon>mdi-card-account-details-outline</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Driver</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-item link router :to="{name: 'armada'}" color="primary lighten-1">
							<v-list-item-action>
								<v-icon>mdi-truck</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Armada</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-group prepend-icon="mdi-map-marker-path" no-action color="primary lighten-1">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>Ekspedisi</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item router :to="{name: 'expedition-schedule'}" color="primary lighten-1">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Buat Jadwal Ekspedisi</span>
											</v-tooltip>
										</span>
										<span v-else>Buat Jadwal Ekspedisi</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'expedition-tracking'}" color="primary lighten-1">
								<v-list-item-content @click="smallDrawer">
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Pelacakan Ekspedisi</span>
											</v-tooltip>
										</span>
										<span v-else>Pelacakan Ekspedisi</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item link router :to="{name: 'expedition-report'}" color="primary lighten-1">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Laporan Ekspedisi</span>
											</v-tooltip>
										</span>
										<span v-else>Laporan Ekspedisi</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
					</div>
				</v-list>
			</v-navigation-drawer>

			<toolbar v-on:childToParent="clickDrawer" />

			<v-main>
				<v-container class="" fluid>
					<v-row align="center" justify="center">
						<v-col class="pl-5 pr-5">
							<v-snackbar v-model="snackbar.show" timeout="2000" right top :color="snackbar.color">
								{{snackbar.text}}
								<template v-slot:action="{ attrs }">
									<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</template>
							</v-snackbar>
							<router-view />
						</v-col>
					</v-row>
				</v-container>
			</v-main>
		</v-app>
	</div>
</template>

<script>
import toolbar from '@/components/logistic/Toolbar';
import { mapState, mapMutations } from 'vuex'

export default {
	components: {
		toolbar
	},
	props: {
		source: String,
	},
	computed: {
		// ...mapState('auth', ['userData']),
		...mapState(['snackbar', 'attempting']),
	},
	data: () => ({
		drawer: null,
		navbar: 256,
	}),
	methods: {
		...mapMutations(['hideSnackbar']),

		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 256) {
					this.navbar = 60
				} else {
					this.navbar = 256
				}
			} else {
				this.drawer = !this.drawer
			}
		},
		smallDrawer() {
			this.navbar = 60
		},
		collapseDrawer() {
			if ( this.$route.name == "expedition-tracking" || this.$route.name == "expedition-report-detail" ) {
				this.navbar = 60
			} else {
				this.navbar = 256
			}
		}
	},
	created() {
		this.collapseDrawer()
	}
};
</script>